import axios from 'axios';
import React from 'react';
import { enqueueSnackbar } from 'notistack';
import { ServiceCategoryModel } from 'src/models/services/serviceCategory';
import { API_url } from '../api.setup';

const API_Controller = '/serviceCategory';

export const ServiceCategoryService = {
  getAllServiceCategory: async () => {
    try {
      const response = await axios.get(`${API_url}${API_Controller}/getall`);
      return response.data as ServiceCategoryModel[];
    } catch (error) {
      throw error;
    }
  },

  addServiceCategory: async (serviceToUpdate: ServiceCategoryModel) => {
    try {
      const reqModel = {
        id: serviceToUpdate.id,
        name: serviceToUpdate.name,
        description: serviceToUpdate.description,
        status: serviceToUpdate.status
      };
      const response = await axios.post(
        `${API_url}${API_Controller}`,
        reqModel
      );
      enqueueSnackbar(
        `Service Category ${serviceToUpdate.name} Added Successfully`,
        {
          variant: 'success'
        }
      );
      return response.data as ServiceCategoryModel;
    } catch (error) {
      enqueueSnackbar(
        `Error occured will Adding Service Category ${serviceToUpdate.name}`,
        {
          variant: 'error'
        }
      );
      console.error(error);
      throw error;
    }
  },

  deleteServiceCategory: async (ServiceCategory) => {
    try {
      const response = await axios.delete(
        `${API_url}${API_Controller}/delete?id=${ServiceCategory.id}`
      );
      enqueueSnackbar(
        `Service Category " ${ServiceCategory.name} " Deleted Successfully`,
        {
          variant: 'success'
        }
      );
      return response.data as ServiceCategoryModel;
    } catch (error) {
      enqueueSnackbar(
        `Service category cannot be deleted. Assigned to service`,
        {
          variant: 'error'
        }
      );
      console.error('Error deleting data:', error);
      throw error;
    }
  },

  editServiceCategory: async (editedData: ServiceCategoryModel) => {
    try {
      const response = await axios.put(
        `${API_url}${API_Controller}/update`,
        editedData
      );
      enqueueSnackbar(
        `Service Category " ${editedData.name} " Edited Successfully`,
        {
          variant: 'success'
        }
      );
      return response.data as ServiceCategoryModel;
    } catch (error) {
      enqueueSnackbar(
        `Service Category " ${editedData.name} " Edited Unsuccessfully`,
        {
          variant: 'error'
        }
      );
      throw error;
    }
  },

  uploadServiceCategoryImage: async (file: File, serviceCategoryId: number) => {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await axios.post(
        `${API_url}/serviceCategory/uploadServiceCategoryImage?serviceCategoryId=${serviceCategoryId}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      enqueueSnackbar('Image uploaded successfully!', { variant: 'success' });
      return response.data;
    } catch (error) {
      enqueueSnackbar('Image upload failed!', { variant: 'error' });
      console.error('Image upload failed:', error);
      throw error;
    }
  },

  assignServiceCategoryToCities: async (serviceCategoryId: number, cityIds: number[]) => {
    try {
      const response = await axios.put(
        `${API_url}${API_Controller}/assignServiceCategoryToCities`,
        cityIds,
        { params: { serviceCategoryId } }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getServiceCategoryCityMappings: async (serviceCategoryId: number) => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/GetServiceCategoryCityMappings?serviceCategoryId=${serviceCategoryId}`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateCategoryDisplayOrder: async (displayOrders: { id: number; displayOrder: number | null }[]) => {
    try {
      const response = await axios.put(
        `${API_url}${API_Controller}/updateDisplayOrder`,
        displayOrders
      );
      enqueueSnackbar('Category order updated successfully', { variant: 'success' });
      return response.data;
    } catch (error) {
      enqueueSnackbar('Failed to update category order', { variant: 'error' });
      throw error;
    }
  }

};
